import { CommonSteps } from 'modules/events/basics/enums/commonForms.enums';
import { useYodaForm } from 'services/yodaForm';

const useEmailConfigurationStep = () => {
  const { useWatchStep } = useYodaForm();
  const stepState = useWatchStep(CommonSteps.emailConfigurationStep);

  return {
    stepIsValid: stepState ? stepState.isValid : false,
  };
};

export default useEmailConfigurationStep;
